import { Resource } from "react-admin";
import UserIcon from "@material-ui/icons/AccountBox";
import React from "react";

import List from "./List";
import Show from "./Show";
import Create from "./Create";
import Edit from "./Edit";

import PermissionDenied from "../../components/PermissionDenied";
import { POLICY_USERS } from "../../common/rolesManagement";

export default permissions => (
    <Resource
        name="users"
        icon={UserIcon}
        list={
            permissions &&
            (permissions.includes(POLICY_USERS.READ) ||
                permissions.includes(POLICY_USERS.SELF_READ))
                ? List
                : PermissionDenied
        }
        show={
            permissions &&
            (permissions.includes(POLICY_USERS.READ) ||
                permissions.includes(POLICY_USERS.SELF_READ))
                ? Show
                : PermissionDenied
        }
        create={
            permissions && permissions.includes(POLICY_USERS.CREATE)
                ? Create
                : PermissionDenied
        }
        edit={
            permissions &&
            (permissions.includes(POLICY_USERS.UPDATE) ||
                permissions.includes(POLICY_USERS.SELF_UPDATE))
                ? Edit
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Users/index.js